import IconGreenChecked from "assets/svgs/green-checked.svg";

export default function StepThankyou({ setSteps }) {
  return (
    <div className="text-center py-10 flex justify-center items-center flex-col max-w-sm mx-auto">
      <IconGreenChecked width="133" className="mb-5" />
      <h3 className="text-xl mb-4">Thank You!</h3>
      <p className="text-15 text-gray-400">
        for helping us crowdsolve information
        <br /> about the 250,000 cold cases in the US
      </p>
      <div className="pt-10 text-gray-700 text-sm pb-5">Whats Next?</div>
      <button
        className="ml-auto font-bold rounded-md px-12 py-3 transition bg-yellow-400 text-white mb-5 w-full text-sm"
        type="button"
        onClick={() => setSteps("addSource")}
      >
        Add Another Source in the case
      </button>
      {/* <button
        href=""
        className="border-yellow-400 border font-bold rounded-md px-5 py-3 hover:bg-yellow-400 transition hover:text-white text-sm w-full"
        type="button"
      >
        Find Sources for a Different Case
      </button> */}
    </div>
  );
}
